import { useEffect, useState } from "react";

export const StickyBar = ({ hidden, children }) => {
  const [footerVisible, setFooterVisible] = useState(false);

  useEffect(() => {
    const footer = document.querySelector('[data-testid="site-footer"]');
    if (!footer) return undefined;
    const observer = new IntersectionObserver(([e]) => setFooterVisible(e.isIntersecting));
    observer.observe(footer);
    return () => {
      observer.disconnect();
    };
  }, []);

  const show = !hidden && !footerVisible;
  return (
    <div
      data-testid="mobile-sticky-bar"
      data-visible={show}
      aria-hidden={!show}
      inert={!show}
      className={`fixed inset-x-0 bottom-0 z-30 border-t border-white/10 bg-ink/95 backdrop-blur-xl transition-transform duration-500 lg:hidden ${show ? "translate-y-0" : "translate-y-full"}`}
      style={{ paddingBottom: "env(safe-area-inset-bottom)" }}
    >
      <div className="flex gap-2 px-4 py-3">{children}</div>
    </div>
  );
};
